import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  fieldClasses: {
    width: "512px !important",
    [theme.breakpoints.down("md")]: {
      width: "100% !important",
    },
  },
  fullWidth: {
    width: "100%",
  },
}));
